import Quill from "quill";
let Module = Quill.import("core/module");
import KeyboardModule from "quill/modules/keyboard";
let Parchment = Quill.import('parchment');



class FocusModule extends Module {

    constructor(quill, options) {
        super(quill, options);

        quill.on("selection-change", (range, oldRange, source) => {
            if (range && source === Quill.sources.USER) {
                this.lastSelection = range;
                this.currentBlot = quill.getLine(range.index)[0];

                this.removeFirstEmptyLine()

                // remove focus classes from embeds every time selection changes
                let embeds = quill.root.querySelectorAll('.ql-embed');
                for (let i = 0; i < embeds.length; i++) {
                    embeds[i].classList.remove('isFocused');
                }

                // add new empty line at the start of content if embed is first element
                // otherwise user cannot place cursor above embed
                if (this.currentBlot.statics.blotName === 'embed') {
                    if (range.index == 0) {
                        this.insertNewLineAtStartOfScroll(this.quill);
                    }
                    this.currentBlot.domNode.classList.add('isFocused');
                    this.quill.emitter.emit('embed-focus', this.currentBlot);
                }
                // this.editorRoot.classList.toggle("isFocused", true);
            }
        });

        quill.on("text-change", (delte, oldDelta, source) => {
            if (source !== Quill.sources.SILENT) {
                // TODO: do not focus editor on text change because initial load causes that editor is focused each time page is loaded
                this.lastSelection = quill.getSelection(false);
            }
        });

        this.quill.root.addEventListener("keydown", this.keyDownListener.bind(this));
    }

    keyDownListener(event) {
        let keyCode = event.keyCode;
        // safari on iPad with external keyboard emits keyCode = 0 so we must catch event.key
        if (event.keyCode === 0) {
            switch (event.key) {
                case "UIKeyInputUpArrow":
                    keyCode = KeyboardModule.keys.UP
                    break;
                case "UIKeyInputDownArrow":
                    keyCode = KeyboardModule.keys.DOWN
                    break;
                case "UIKeyInputLeftArrow":
                    keyCode = KeyboardModule.keys.Left
                    break;
                case "UIKeyInputRightArrow":
                    keyCode = KeyboardModule.keys.Right
                    break;
                default:
                    break;
            }
        }

        if (!this.currentBlot) {
            [this.currentBlot] = this.quill.getLeaf(this.quill.getSelection(true).index);
        }

        // Handle delete/backspace
        if (this.isKeyCodeDelete(keyCode)) {
            // If we're in an embed blot we want to delete it.
            if (this.currentBlot.statics.blotName === 'embed') {
                event.preventDefault();
                event.stopPropagation();
                this.currentBlot.remove();
                this.quill.update(Quill.sources.USER);
                this.quill.setSelection(this.lastSelection.index, 0, Quill.sources.USER);

            // Otherwise if we're just in quill normally, we special handling in case the previous item is an embed blot.
            } else if (this.quill.hasFocus()) {
                const eventWasHandled = this.handleDeleteOnQuill();
                if (eventWasHandled) {
                    this.quill.setSelection(this.lastSelection.index, 0, Quill.sources.USER);
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
            }
        }

        // Handle the enter key.
        if (KeyboardModule.match(event, KeyboardModule.keys.ENTER)) {
            if (this.currentBlot.statics.blotName === 'embed') {
                event.preventDefault();
                event.stopPropagation();
                this.currentBlot.insertNewlineAfter();
            }
        }

        this.quill.update(Quill.sources.USER);
    }

    removeFirstEmptyLine() {
        let firstLineBlot = this.quill.getLine(0)[0];
        if (firstLineBlot
            && firstLineBlot.statics.blotName === 'block'
            && firstLineBlot.domNode.textContent === "" && this.quill.getSelection(true).index > 1
            ) {
            firstLineBlot.remove();
            this.removeFirstEmptyLine();
        }
    }

    handleDeleteOnQuill() {
        if (!this.currentBlot) {
            return false;
        }

        const previousBlot = this.currentBlot.prev;
        const isCurrentBlotEmpty = this.currentBlot.domNode.textContent === "";
        if (previousBlot && previousBlot.statics.blotName === 'embed' && isCurrentBlotEmpty) {
            if (this.currentBlot.statics.blotName === 'break') {
                this.currentBlot.parent.remove();
            }
            this.currentBlot.remove();
            return true;
        }

        return false;
    }

    isKeyCodeDelete(keyCode) {
        const { BACKSPACE, DELETE } = KeyboardModule.keys;
        return [BACKSPACE, DELETE].includes(keyCode);
    }

    insertNewLineAtStartOfScroll(quill) {
        const newLineBlot = Parchment.create("block", "");
        quill.scroll.insertBefore(newLineBlot, quill.scroll.children.head);
        quill.update(Quill.sources.USER);
    }
}

export default FocusModule;
